import React from "react";
import styled from "styled-components";
import { Colors } from "../config";

const Modal = ({ children, setClose, width }) => {
  return (
    <>
      <ModalBackground onClick={() => setClose(false)}></ModalBackground>
      <ModalContainer width={width}>{children}</ModalContainer>
    </>
  );
};

export default Modal;

const ModalBackground = styled.div`
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 100;
  background: ${Colors.shark};
  opacity: 0.9;
  position: fixed;
  cursor: pointer;
`;
const ModalContainer = styled.div`
  width: ${(props) => props.width};
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  border-radius: 1.25rem;
  background-color: ${Colors.white};
`;
